var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('el-carousel',{class:_vm.pageView == 1 ? 'setbg1' : 'setbg2',attrs:{"type":_vm.pageView == 1 ? 'card' : '',"interval":_vm.during,"height":_vm.setHeight}},_vm._l((_vm.imgUrl),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"big",attrs:{"src":item.img,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }